import React from "react";
import result1 from './images/result1.png';
import result2 from './images/result2.png';

function CourseTestimonial (){
    return (
        <section className="py-5 classroom-card">
            <div className="container">
                <h3>NEET Result-2025</h3>
                <div id="cardCarousel" className="carousel slide" data-bs-ride="carousel">
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                            <div className="card">
                                <img src={result1} className="card-img-top" alt="Slide 1" />
                            </div>
                        </div>
                        <div className="carousel-item">
                            <div className="card">
                                <img src={result2} className="card-img-top" alt="Slide 2" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-flex justify-content-center align-items-center mt-3">
                    <div>
                        <button className="btn btnarrow me-1" type="button" data-bs-target="#cardCarousel" data-bs-slide="prev"><i class="bi bi-arrow-left"></i></button>
                        <button className="btn btnarrow" type="button" data-bs-target="#cardCarousel" data-bs-slide="next"><i className="bi bi-arrow-right"></i></button>
                    </div>
                </div>
            </div>
        </section>
    );
}
export default CourseTestimonial;